<ng-container *ngIf="open">
  <div class="modal" (click)="close()">
    <tm1-card class="modal-content add-widget-content" [class.dark]="dark"
      (click)="$event.stopPropagation()">
      <span class="close" (click)="close()">&times;</span>
      <h2 class="add-widget-title">Add a widget</h2>
      <input type="text" class="add-widget-search" [(ngModel)]="query"
        placeholder="Search widgets" autocomplete="off" aria-label="Search widgets" />
      <div class="add-widget-list">
        <button type="button" class="add-widget-option" *ngFor="let opt of filteredOptions"
          (click)="choose(opt.type)">
          <span class="add-widget-option-label">{{ opt.label }}</span>
          <span class="add-widget-option-desc">{{ opt.description }}</span>
        </button>
        <p class="add-widget-empty" *ngIf="filteredOptions.length === 0">
          No widgets match &ldquo;{{ query }}&rdquo;.
        </p>
      </div>
    </tm1-card>
  </div>
</ng-container>
